/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the OrderFlagRequestDTO interface.
 */
export function instanceOfOrderFlagRequestDTO(value) {
    if (!('name' in value) || value['name'] === undefined)
        return false;
    return true;
}
export function OrderFlagRequestDTOFromJSON(json) {
    return OrderFlagRequestDTOFromJSONTyped(json, false);
}
export function OrderFlagRequestDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'],
        'color': json['color'] == null ? undefined : json['color'],
    };
}
export function OrderFlagRequestDTOToJSON(json) {
    return OrderFlagRequestDTOToJSONTyped(json, false);
}
export function OrderFlagRequestDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
        'color': value['color'],
    };
}
